import { atomWithQuery } from "jotai-tanstack-query";
import {
  fetchCbdCases,
  fetchCbdContentByType,
  fetchCbdQuizContentByNodeId,
  fetchCbdQuizForCaseById,
  fetchOnlyCpdContentByQueryParams,
  fetchCpdContentNodesByQueryParams,
  fetchCbdContentNodeById,
  fetchCbdContentTablesForNodeById,
  fetchCbdCasesById,
  fetchCbdContentSubNodesForNodeById,
} from "../cpd";
import { FormType } from "../../pages/cms/cpd/quiz/form.builder";

export const cdbContentByIdQueryAtom = (nodeId) =>
  atomWithQuery(() => ({
    queryKey: ["cbdContentNode", nodeId],
    queryFn: () => fetchCbdContentNodeById(nodeId),
    enabled: !!nodeId,
    refetchOnWindowFocus: false,
  }));

export const cdbContentByTypeQueryAtom = (nodeType) =>
  atomWithQuery(() => ({
    queryKey: ["cbdContentNodesByType", nodeType],
    queryFn: () => fetchCbdContentByType(nodeType),
    refetchOnWindowFocus: false,
  }));

export const cpdContentNodesByQueryParamsAtom = (params) => {
  return atomWithQuery(() => ({
    queryKey: ["cbdContentNodes", params],
    queryFn: () => fetchCpdContentNodesByQueryParams(params),
    refetchOnWindowFocus: false,
  }));
};

export const cpdContentByParamsQueryAtom = (params) =>
  atomWithQuery(() => ({
    queryKey: ["cpdOnlyConditions", params],
    queryFn: () => fetchOnlyCpdContentByQueryParams(params),
    refetchOnWindowFocus: false,
  }));

export const cpdContentCases = (params) => {
  return atomWithQuery(() => ({
    queryKey: ["cpdCasesContent", params],
    queryFn: () => fetchCbdCases({...params}),
    refetchOnWindowFocus: false,
  }));
};

export const cpdContentCaseById = (caseId) => {
  return atomWithQuery(() => ({
    queryKey: ["cpdCaseContent", caseId],
    queryFn: () => fetchCbdCasesById(caseId),
    refetchOnWindowFocus: false,
  }));
};

export const cpdQuizContentByIdQueryAtom = (objectId, objectType) => {
  const queryKey =
    objectType === FormType?.CASE ? "cpdQuizForCaseContent" : "cpdQuizContent";
  const queryFn =
    objectType === FormType?.CASE
      ? () => fetchCbdQuizForCaseById(objectId)
      : () => fetchCbdQuizContentByNodeId(objectId);
  return atomWithQuery(() => ({
    queryKey: [queryKey, objectId],
    queryFn: () => queryFn(),
     enabled: !!objectId, 
    refetchOnWindowFocus: false,
  }));
};

export const cpdContentTablesForNodeById = (nodeId) => {
  return atomWithQuery(() => ({
    queryKey: ["cpdContentTablesForNodeById", nodeId],
    queryFn: () => fetchCbdContentTablesForNodeById(nodeId),
    enabled:!!nodeId,
    refetchOnWindowFocus: false,
  }));
};

export const cpdContentSubNodesForNodeById = (nodeId) => {
  return atomWithQuery(() => ({
    queryKey: ["cpdContentSubNodesForNodeById", nodeId],
    queryFn: () => fetchCbdContentSubNodesForNodeById(nodeId),
    enabled: !!nodeId,
    refetchOnWindowFocus: false,
  }));
};


